enum AlertSeverityEnum {
  HEALTHY,
  MINOR,
  MAJOR,
  CRITICAL,
  UNKNOWN,
}

export default AlertSeverityEnum;